export const FirebaseCollections = {
  Comercial: "comercial",
  Pcp: "ing",
  Clients: "clientes",
  Telas: "telas",
  Corte: "corte",
};
